import { Icon, Image } from '@acme/assets';
import { Button, Card } from 'flowbite-react';
import type { $result } from '../model';

export const ResultScreen = ({
  result,
  onBack,
  onHome,
}: {
  result: NonNullable<ReturnType<typeof $result.getState>>;
  onBack: () => void;
  onHome: () => void;
}) => {
  const isError = result.type.startsWith('failed');
  return (
    <div className="w-full h-full flex items-center justify-center min-w-112">
      <Card className="p-6 flex flex-col justify-center items-center max-w-xl">
        <div className="flex justify-center items-center">
          {isError && (
            <div
              className={
                'p-4 rounded-full text-red-600 bg-red-100 flex items-center justify-center'
              }
            >
              <Icon size={24} name="x-outline" />
            </div>
          )}
          {!isError && (
            <Image name="application-succes" width={160} height={160} />
          )}
        </div>
        <div className="text-center ">
          <div className="font-medium">{result.title}</div>
          {result.message && (
            <div className="text-gray-500">{result.message}</div>
          )}
        </div>
        <div className="text-center items-center flex w-full">
          {isError && (
            <div
              className="flex justify-center items-center gap-1"
              onClick={onBack}
            >
              <Icon name="arrow-left" /> Вернуться на страницу заявки
            </div>
          )}
          {!isError && (
            <Button color="primary" className="mx-auto" onClick={onHome}>
              На главную
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};
